import { getSettingShipWithFaireEnabledCountries } from "@faire/help-center-utils/settings/getSettingShipWithFaireEnabledCountries";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

export const isSWFAvailableInCountry = (
  countryISO: keyof typeof ISO3166Alpha3
) => {
  return getSettingShipWithFaireEnabledCountries().includes(countryISO);
};
